import { EmpUpdateProfileForm } from "../../components/emp/EmpUpdateProfileForm";

import React from "react";
import Grid from '@mui/material/Grid';
import { useParams } from "react-router-dom";
import { AuthHelper } from '../../utils/auth_helper';


function EmpUpdateProfile() {

  return (
    <div>
      <AuthHelper />

      <div className="tw-px-5 tw-w-96 tw-inline-block tw-justify-center sm:tw-ml-20 tw-text-left">

        <Grid container direction="row" alignItems="center" justifyContent="" >

          <Grid container>
            <Grid item xs={12} sm={12}>
              <span className="tw-p-10 tw-text-3xl"><p>Update Employee Profile</p></span>
            </Grid>
          </Grid>

          <EmpUpdateProfileForm />

        </Grid>

      </div>

    </div>
  );

}


export { EmpUpdateProfile };
